import BackboneElement from './BackboneElement';
import ClaimResponseItemDetail from './ClaimResponseItemDetail';
import merge from 'lodash/merge';
import Period from './types/Period';
import ClaimResponseItemAdjudication from './ClaimResponseItemAdjudication';

export default class ClaimResponseItem extends BackboneElement {
    static __className = 'ClaimResponseItem';

    __objectStructure = {
        preAuthPeriod: Period,
        preAuthNumber: String,
        itemSequence: Number,
        authorizedItemDetail: ClaimResponseItemDetail,
        adjudication: [ClaimResponseItemAdjudication],
        note: String,
    };

    constructor(constructJson, className = 'ClaimResponseItem') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
